import { size, isEmpty } from 'lodash'
import moment from 'moment'
import React, { Component } from 'react'
import { Alert, Collapse, Input, ModalHeader } from 'reactstrap'
import CKEditorUI from '../../components/CKEditor/CKEditorUI'
import PriorityContainer from '../../components/PriorityContainer/PriorityContainer'
import * as url from '../../utils/url'
import { Modal, ModalBody, Button, Row, Col } from 'reactstrap'
import Toggle from 'react-toggle'
import DatePicker from 'react-datepicker'
import {
  taskValidation,
  task_priority,
  placeholder_text,
  privacyMap,
  checkValidityForAnonymousToggleCreate,
  privacy_options,
} from '../../utils/constants'
import ReactTooltip from 'react-tooltip'
import axios from '../../axios'
import AssigneeDropdown from './AssigneeDropdown'
import { isMobile } from '../../utils/deviceInfo'
import Checkbox from 'rc-checkbox'
import { BiChevronLeft, BiX, BiLink, BiLock, BiTimeFive } from 'react-icons/bi'
import Select from 'react-select/lib/Select'

export default class extends Component {
  constructor(props) {
    super(props)
    const hideAnonymous =
      props.user.profile && props.user.profile.organizationId.disableAnonymity
        ? checkValidityForAnonymousToggleCreate(
            'planning',
            props.user.profile.organizationId.disableAnonymity
          )
        : false

    this.state = {
      inputText: '',
      selectedTodoTitle: '',
      title: '',
      assignedUser: {},
      isDueDate: false,
      dueDate: moment(new Date()),
      modalActionType: 'Create',
      isAnonymous: false,
      isAnonymousVisible: !hideAnonymous,
      enterpriseObjectives: [],
      enterpriseObjectivesCopy: [],
      isEnterpiseObjectiveSelected: false,
      objectiveId: '',
      actionId: '',
      dateError: false,
      priority: 0,
      description: {
        value: '',
        error: false,
      },
      userId: {},
      selectedObjective: {},

      isEObj: false,
      privacy: 0,
      showPublicAlert: false,
      showPrivateTasksEoAlert: false,
      showLinkObjAlert: false,
    }
  }

  componentDidMount() {
    setTimeout(() => {
      if (this.props.description.value) {
        this.setState({ description: this.props.description })
      } else {
        this.setState({
          description: {
            value: `<p>${placeholder_text.action_create}</p>\n`,
            error: false,
          },
        })
      }
    }, 300)
  }

  handleChangeObjectiveTitle = (event) => {
    const { value } = event.target
    this.setState({
      // title: { value: value },
      title: value,
      selectedTodoTitle: value,
      //   description: {
      //     value: "",
      //     error: false,
      //   },
    })
  }

  handleChangeGoalDescription = (event) => {
    const descriptionContext = event.editor.getData()
    this.setState({ description: { value: descriptionContext } })
  }

  handleGoalDateChange = (date) => {
    let obj
    // console.log('date---', date)
    if (moment(date).format('YYYY-MM-DD') < moment().format('YYYY-MM-DD')) {
      obj = {
        dateError: 'Due date can not be set in the past',
      }
    } else {
      obj = {
        dueDate: date,
        dateError: false,
        // isAssigned: false,
      }
    }
    this.setState({
      ...obj,
    })
  }

  assignedUserFormat = (selectedUser) => {
    // console.log(selectedUser)
    let obj = {
      fullName: `${selectedUser.firstName} ${selectedUser.lastName}`,
      user: selectedUser,
    }
    this.setState({ assignedUser: obj, users: [] })
    return obj
  }

  removeTaskValue = (field) => {
    let { task_copy, removedFields, updatedFields } = this.state
    task_copy = { ...task_copy, [field]: null }

    if (field == 'assignedTo') {
      task_copy = { ...task_copy, assignedToDoc: null, assignedUser: {} }
    }

    this.setState({
      task_copy,
      assignedToDoc: null,
      assignedUser: {},
      // removedFields,
      // updatedFields: updatedFields.filter(e => e != field),
    })
  }

  handleChangeTaskName = ({ target }) => {
    this.setState({ title: target.value })
  }

  handleObjective = (e) => {
    this.setState({ enterpiseObjective: !this.state.enterpiseObjective })
  }

  assignedUserDelay = ({ target }) => {
    const { value } = target
    // console.log('alp----', value)
    this.setState({ assignedUser: { fullName: value } })

    clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      this.handleAssignUser(value)
    }, 1000)
  }

  handleAssignUser = (value) => {
    // const { password } = this.state;
    // password.value = value;
    // password.error = false;
    // console.log('val---', value)
    if (value && value.length > 0) {
      axios.get(url.findUser(value)).then((resp, idx) => {
        let users = resp.data.data
        // console.log('users--', users)
        if (users.length == 0) {
          users = 'No users were found'
        }
        // console.log( 'type---',typeof(users) )
        this.setState({ users })
      })
    } else {
      this.setState({ users: [] })
    }
  }

  handleDatePicker = (id) => {
    document.getElementById(id).click()
  }

  handleEnterpriseObjectiveChange = (itemObject, selected) => {
    this.setState({
      isEnterpiseObjectiveSelected: selected,
      objectiveId: itemObject._id,
    })
  }

  handlePermissionChange = (changeEvent) => {
    this.setState({
      isAnonymous: changeEvent.target.checked,
    })
  }

  handleAssignedChange = (changeEvent) => {
    let checkValue = changeEvent.target.checked

    let stateUpdate = {
      isAssigned: changeEvent.target.checked,
    }

    if (!checkValue) {
      stateUpdate.users = []
      stateUpdate.assignedUser = {}
    }

    this.setState(stateUpdate)
  }

  handleDueDateChange = (changeEvent) => {
    this.setState({
      isDueDate: changeEvent.target.checked,
      dueDate: moment(new Date()),
    })
  }

  handleSubmitTodo = (actionTitle) => {
    let {
      isAnonymous,
      title,
      description,
      privacy,
      parentTaskDateAdded,
      enterpiseObjective,
      edit,
      toolID,
      assignedUser,
      dueDate,
      isDueDate,
      dateError,
      selectedTodoTitle,
      userId,
      priority,
      selectedObjective,
    } = this.state

    const {
      parentActionId,
      showPublicActions,
      parentActionPrivacy,
      tableType,
    } = this.props

    let currentUser = this.props.user.profile

    let recipient

    let payload = {
      description: description.value,
      privacy:
        tableType == 'subAction'
          ? parentActionPrivacy
          : privacy == 2
          ? selectedObjective && selectedObjective._id
            ? 2
            : 1
          : privacy,
      title,
      isAnonymous,
      parentTaskDateAdded,
      priority: priority,
    }
    if (selectedTodoTitle) {
      payload.title = selectedTodoTitle
    }

    if (assignedUser && assignedUser.user) {
      payload.assignedUser = assignedUser.user
      recipient = currentUser._id === userId._id ? userId : assignedUser.user
      payload.recipient = recipient
    }

    if (tableType != 'subAction') {
      if (currentUser.role != 'Admin') {
        payload.assignedUser = currentUser
      }
    }

    if (isDueDate) {
      payload.dueDate = dueDate
    }

    //if (isAnonymous) {
    //  payload.isAnonymous = isAnonymous;
    //} else if (isAnonymous === undefined) {
    //  payload.isAnonymous = false;
    //}
    payload.parentTaskDateAdded = ''

    let isErrorCheck = taskValidation(payload)

    let apiUrl = url.addTodo
    let apiPostData = { ...payload }

    if (parentActionId) {
      // apiUrl = url.editTodo;
      apiPostData = {
        parentActionId: parentActionId,
        ...payload,
        type: 'subAction',
        // task: { ...payload },
      }
    }

    if (isErrorCheck.length == 0) {
      axios.post(apiUrl, apiPostData).then(({ data }) => {
        const todo = data.data

        this.setState({
          inputText: '',
          errorSubmit: '',
          dateError: false,
          inputText: '',
          description: '',
          title: '',
          selectedTodoTitle: '',
          privacy: 0,
          enterpiseObjective: false,
          users: [],
          isDueDate: false,
          isAssigned: false,
          showModal: false,
          assignedUser: {},
          dueDate: moment(new Date()),
          isDueDate: false,
          assignedUser: {},
          dueDate: moment(new Date()),
          selectedTodoTitle: '',
          enterpiseObjective: false,
          edit: false,
          priority: 0,
        })
        const updateInTable = () => {
          // if (todo.privacy === 0) {
          //   this.props.onClose();
          // } else {
          let orgId = this.props.user.profile.organizationId._id
          let id = todo._id
          let userId = this.props.user.profile._id

          let params = {
            orgId,
            task: id,
            userId,
          }
          axios
            .get(url.getSingleTask, {
              params: params,
            })
            .then(({ data }) => {
              const task = data.data
              if (
                task.parentTask &&
                task.parentTask.item &&
                task.parentTask.item._id
              ) {
                task['parentTaskTitle'] = task.parentTask.item.title
                task.parentTask.item = task.parentTask.item._id
              }
              this.props.onAddSuccess(task)
            })
            .catch((err) => console.log(err))
          // }
        }

        if (
          (privacy === 1 || privacy === 2) &&
          selectedObjective &&
          selectedObjective._id
        ) {
          let obj = {
            objectiveId:
              selectedObjective && selectedObjective._id
                ? selectedObjective._id
                : false,
            isAnonymous: isAnonymous,
            actionId: todo._id,
          }
          axios
            .post(url.linkEnterpriseObjectiveAction, obj)
            .then(({ data }) => {
              let newTask = data.data
              updateInTable()
            })
            .catch((err) => console.log(err))
        } else {
          updateInTable()
        }
      })
    } else {
      this.setState({
        errorSubmit: `Please correct the following errors: ${isErrorCheck.join(
          ', '
        )}.`,
      })
    }
    // this.setState({ showModal: false, description: "", title: "", selectedTodoTitle: "", enterpiseObjective: false, privacy: true })
  }

  handlePriorityChange = (task) => {
    this.setState({ priority: task.priority })
  }
  navigateToEO = (id) => {
    this.props.history.push(`/home/enterprise-associatedActions/${id}`)
  }
  getEOList = () => {
    let orgId = this.props.user.profile.organizationId._id

    axios
      .get(`${url.getEnterpriseObjectives}/${orgId}`, {
        params: {
          removeDeleted: true,
        },
      })
      .then(({ data }) => {
        this.setState({
          enterpriseObjectives: [...data.data.taskList],
          enterpriseObjectivesCopy: [...data.data.taskList],
          // updatedFields
        })
      })
  }

  addEntObj = (eo) => {
    let { selectedObjective } = this.state
    if (selectedObjective._id != eo._id) {
      this.setState({
        selectedObjective: { ...eo },
        privacy: 2,
        showPublicAlert: true,
        showLinkObjAlert: false,
      })
    } else {
      this.setState({
        selectedObjective: {},
        showPublicAlert: false,
        showLinkObjAlert: false,
      })
    }
  }

  handleChangePrivacy = (val) => {
    let { selectedObjective } = this.state
    let priv = val

    if (!isEmpty(this.state.selectedObjective) && priv === 0) {
      this.setState({
        //privacy: priv,
        //selectedObjective: {},
        showPublicAlert: false,
        showPrivateTasksEoAlert: true,
        showLinkObjAlert: false,
      })
    } else if (priv == 2 && (!selectedObjective || !selectedObjective._id)) {
      this.setState({
        privacy: priv,
        showPrivateTasksEoAlert: false,
        showLinkObjAlert: true,
      })
    } else {
      this.setState({
        privacy: priv,
        showPrivateTasksEoAlert: false,
        showLinkObjAlert: false,
      })
    }
  }

  setPrivacyToPrivateAndRemoveEOIfLinked = () => {
    this.setState({
      privacy: 0,
      showPrivateTasksEoAlert: false,
    })

    this.addEntObj(this.state.selectedObjective)
  }

  renderFormUI = () => {
    const { parentActionId, parentActionTitle, tableType } = this.props
    let {
      description,
      title,
      isAssigned,
      isDueDate,
      dueDate,
      users,
      assignedUser,
      dateError,
      errorSubmit,
      priority,
      enterpriseObjectives,
      isEObj,
      selectedObjective,
      isAnonymous,
      privacy,
      enterpriseObjectivesCopy,
      showPublicAlert,
      showPrivateTasksEoAlert,
      showLinkObjAlert,
    } = this.state
    return (
      <div style={{ padding: '40px', minHeight: '560px', paddingTop: '20px' }}>
        {parentActionTitle ? (
          <h5 className="mb-3">Parent action : {parentActionTitle || ''}</h5>
        ) : (
          ''
        )}
        <div className="inner-addon right-addon createTaskModalInputContainer">
          <Input
            type="text"
            name="objectiveTitle"
            onChange={this.handleChangeObjectiveTitle}
            value={title}
            placeholder={
              parentActionTitle
                ? 'Please provide an subaction title*'
                : 'Please provide an Action title*'
            }
            className="mb20 singleTaskTitleEdit"
            maxLength={64}
          />
          <span className="createTaskModalCharCount">{`${size(
            title
          )}/64`}</span>
        </div>

        {/* <Title editTitle={this.state.selectedTodoTitle} /> */}

        <span className="addTaskHeaders">Description*</span>
        <div style={{ marginBottom: '40px' }}>
          <CKEditorUI
            onChange={this.handleChangeGoalDescription}
            value={description.value || ' '}
            afterPaste={(e) => console.log(e)}
          />
        </div>

        <span>
          {this.props.user.profile.orgAdmin ||
          this.props.user.profile.role == 'Admin' ||
          tableType == 'subAction' ? (
            <AssigneeDropdown
              textContainerStyle={{ marginLeft: '0.8em' }}
              currentUser={this.props.user.profile}
              tasAssignedUser={
                !isEmpty(this.state.assignedUser)
                  ? this.state.assignedUser.user
                  : null
              }
              editTask={() => {}}
              removeUser={() => this.removeTaskValue('assignedTo')}
              assignedUserFormat={this.assignedUserFormat}
              task={{
                assignedTo: !isEmpty(this.state.assignedUser)
                  ? this.state.assignedUser.user
                  : null,
              }}
              helpText={'Assign to user'}
            />
          ) : null}
        </span>

        <Row style={{ marginTop: '40px' }}>
          <span style={{ marginLeft: '1.2em' }}>
            <BiTimeFive size={'26px'} color={'#B7B3B2'} />
          </span>

          <span className="planningOptions ml10"> Add a due date </span>

          <span className="crt-task-spacing">
            <Toggle
              checked={isDueDate}
              // icons={false}
              onChange={this.handleDueDateChange}
            />
          </span>

          {isDueDate ? (
            <div>
              <DatePicker
                id="actionDueDate"
                placeholderText="Enter date: MM/DD/YYYY"
                className="set-goal input-custom-date form-control"
                selected={dueDate}
                onChange={this.handleGoalDateChange}
                minDate={moment(new Date())}
                // isClearable={true}
                showYearDropdown
              />
            </div>
          ) : null}
          {dateError != false ? (
            <span className="errorMsg">{dateError}</span>
          ) : null}
        </Row>

        <Row style={{ marginTop: '40px', paddingLeft: '7px' }}>
          <PriorityContainer
            isActive={true}
            index={-1}
            size={'40px'}
            task={{ priority: priority }}
            handlePriorityChange={this.handlePriorityChange}
            canEdit={true}
          />
        </Row>

        {tableType !== 'subAction' && (
          <div>
            <Row style={{ marginTop: '35px' }} className="align-items-center">
              <span className="cursor-pointer" style={{ marginLeft: '1.2em' }}>
                {' '}
                <BiLock size={'26px'} color={'#B7B3B2'} />{' '}
              </span>

              <span className="planningOptions ">Privacy</span>

              <div style={{ width: '150px' }}>
                {/* <Toggle
              checked={privacy === 1}
              icon={false}
              onChange={this.handleChangePrivacy}
              className="mt-1"
            /> */}
                <Select
                  value={privacy}
                  label="Select Privacy"
                  onChange={(e) => {
                    if (e) {
                      this.handleChangePrivacy(e.value)
                    } else {
                      this.handleChangePrivacy(null)
                    }
                  }}
                  placeholder="Select privacy"
                  options={
                    tableType == 'subAction'
                      ? privacy_options.filter((x) => x.value != 2)
                      : privacy_options
                  }
                />
                {/* <span className="planningOptions" style={{ marginBottom: "2px" }}>
              {privacyMap[privacy]}
            </span> */}
              </div>
            </Row>
            {showPublicAlert && (
              <Alert color={'info'} className="mt-2">
                By adding an objective your action will be made public and
                linked
              </Alert>
            )}

            {tableType !== 'subAction' && this.state.showLinkObjAlert ? (
              <span>
                <Alert color={'info'} className="mt-2">
                  Please link enterprise objective from bottom.
                </Alert>
              </span>
            ) : (
              ''
            )}

            {showPrivateTasksEoAlert && (
              <span>
                <Alert color="info">
                  <div>
                    Changing the privacy to Private will unlink this action from
                    the Objective. Do you want to proceed?
                  </div>
                  <div>
                    <Button
                      onClick={() =>
                        this.setPrivacyToPrivateAndRemoveEOIfLinked()
                      }
                      color="success"
                      size="sm">
                      Yes
                    </Button>
                    <Button
                      className="ml-2"
                      onClick={() => {
                        this.setState({
                          showPrivateTasksEoAlert: false,
                        })
                      }}
                      color="danger"
                      size="sm">
                      No
                    </Button>
                  </div>
                </Alert>
              </span>
            )}
          </div>
        )}

        <div>
          {tableType !== 'subAction' && (
            <div className="eo-link-div mt-4">
              {isEObj ? (
                <div>
                  {' '}
                  Link to one of the Objectives below:
                  <div
                    className="singleActionAnonymous"
                    hidden={!this.state.isAnonymousVisible}>
                    <span className="">
                      <Toggle
                        checked={isAnonymous}
                        icons={false}
                        onChange={this.handlePermissionChange}
                      />
                    </span>
                    <span className="permission-value ml10">Anonymous</span>
                  </div>
                  {enterpriseObjectivesCopy.length > 0 && (
                    <Input
                      className="search-eo-input"
                      placeholder="Type objective title ...."
                      onChange={(e) => {
                        const value = e.target.value

                        let objectives = [
                          ...this.state.enterpriseObjectivesCopy,
                        ]

                        if (value) {
                          objectives = objectives.filter((eo) =>
                            eo.title.toLowerCase().includes(value.toLowerCase())
                          )
                          this.setState({
                            enterpriseObjectives: [...objectives],
                          })
                        } else {
                          objectives = [...this.state.enterpriseObjectivesCopy]
                          this.setState({
                            enterpriseObjectives: [...objectives],
                          })
                        }
                      }}
                    />
                  )}
                  {enterpriseObjectives && enterpriseObjectives.length > 0 ? (
                    <div className="divTableSingleTask">
                      <div className="divTableBody">
                        {enterpriseObjectives.map((eo, idx) => {
                          return (
                            <span key={eo._id + idx}>
                              <Checkbox
                                className="singleTaskLinkCheckBox"
                                checked={
                                  selectedObjective &&
                                  selectedObjective._id === eo._id
                                }
                                type="checkbox"
                                onClick={() => this.addEntObj(eo)}
                              />

                              {eo.title}
                            </span>
                          )
                        })}
                      </div>
                    </div>
                  ) : null}
                  <div
                    className="singleTaskModalBtn"
                    style={{ padding: '10px 0px 0px 0px' }}>
                    <Button
                      className="profile-modal-cancel-btn weeklyWinBtn mb-10"
                      onClick={() => this.setState({ isEObj: false })}>
                      <span className="profile-modal-cancel-btn-txt">
                        Close
                      </span>
                    </Button>
                  </div>
                </div>
              ) : (
                <div>
                  {selectedObjective._id ? (
                    <div className="singleTaskEOContainter">
                      <span className="flaticon-clip singleTaskIconClass"></span>
                      <span
                        className="singleTaskEO"
                        onClick={() =>
                          this.navigateToEO(selectedObjective._id)
                        }>
                        Part of{' '}
                        <span
                          className="tooltip-text"
                          data-tip={selectedObjective.title}>
                          <span className="entObjTitle">
                            {selectedObjective.title}
                          </span>{' '}
                          enterprise objective{' '}
                        </span>
                      </span>
                      <ReactTooltip />

                      {/* linked objective VIEW */}
                      {/* <a
        className="card-link singleTaskEditBtn"
        onClick={() => this.navigateToEO(selectedObjective._id)}
      >
        {" "}
        View
      </a> */}

                      <a
                        className="card-link singleTaskEditBtn"
                        onClick={() => this.setState({ isEObj: true })}>
                        {' '}
                        Edit
                      </a>
                    </div>
                  ) : (
                    <span
                      className={'singleTaskEO card-link'}
                      onClick={() => {
                        if (enterpriseObjectives.length) {
                          this.setState({ isEObj: true })
                        } else {
                          this.getEOList()
                          this.setState({ isEObj: true })
                        }
                      }}>
                      {' '}
                      <BiLink className="create-action-modal-link-eo" /> Link to
                      Objective{' '}
                    </span>
                  )}
                </div>
              )}
            </div>
          )}
        </div>

        <div className="submitTodoContainer mt20">
          <Button
            className={`profile-modal-save-btn ${
              tableType === 'subAction' ? 'weeklyWinBtn-lg' : 'weeklyWinBtn'
            }`}
            onClick={this.handleSubmitTodo}
            disabled={isEmpty(title && description) && dateError}>
            <span className="profile-modal-save-btn-txt">
              {tableType === 'subAction' ? 'Submit subaction' : 'Submit'}{' '}
              <span className="ml10 flaticon-tick"></span>
            </span>
          </Button>
          <Button
            className="profile-modal-cancel-btn float-right weeklyWinBtn"
            onClick={() => this.props.onClose()}>
            <span className="profile-modal-cancel-btn-txt">Cancel</span>
          </Button>
        </div>

        {errorSubmit != '' ? (
          <span className="taskErrorSubmit">{errorSubmit}</span>
        ) : null}

        <div
          closeModal={() => this.props.onClose()}
          submitTodo={this.handleSubmitTodo}
          description={description.value}
        />
      </div>
    )
  }

  render() {
    const {
      parentActionId,
      parentActionTitle,
      tableType,
      parentActionPrivacy,
    } = this.props
    return (
      <div>
        {tableType !== 'subAction' ? (
          <Modal isOpen={this.props.open} className="createTaskModal">
            <ModalHeader className={'edit-modal-actions'}>
              {!isMobile ? (
                <Row>
                  <Col md={10} xs={10} className="title-and-tabs-edit mt-2">
                    <h5>
                      {parentActionId
                        ? 'Create a new subaction'
                        : 'Create a new action'}{' '}
                    </h5>
                  </Col>

                  <Col md={2} xs={2} className="px-1">
                    <div className="text-right pt-1 px-2">
                      <Button className="p-1 mx-1" color="light">
                        <BiX
                          size={'26px'}
                          onClick={() => this.props.onClose()}
                        />
                      </Button>
                    </div>
                  </Col>
                </Row>
              ) : (
                <Row>
                  <Col xs={2} className="px-1">
                    <div className="text-right pt-2 px-2">
                      <Button className="mx-1" color="transparent">
                        <BiChevronLeft
                          size={'26px'}
                          onClick={() => this.props.onClose()}
                        />
                      </Button>
                    </div>
                  </Col>

                  <Col xs={8} className="pt-3 px-1">
                    <h5>Create a new action</h5>
                  </Col>
                </Row>
              )}
            </ModalHeader>
            <ModalBody>{this.renderFormUI()}</ModalBody>
          </Modal>
        ) : (
          <Collapse className="create-task-collapse" isOpen={this.props.open}>
            {this.renderFormUI()}
          </Collapse>
        )}
      </div>
    )
  }
}
